import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";
import { toast } from "sonner";

export default function CandidateApplications() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/applications");
    setItems(data.items || []);
  };
  useEffect(() => { load(); }, []);

  const withdraw = async (id) => {
    await api.put(`/applications/${id}`, { withdrawn: true });
    toast.success("Withdrawn");
    load();
  };

  return (
    <div>
      <div className="mb-6">
        <div className="eyebrow mb-2">Candidate</div>
        <h1 className="font-display text-3xl font-bold text-navy">My Applications</h1>
      </div>
      <div data-testid={TID.candidateApplicationsTable} className="border border-slate-200 rounded-xl bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b">
            <tr className="text-left text-slate-500">
              <th className="p-3">Role</th><th className="p-3">Employer</th><th className="p-3">Status</th>
              <th className="p-3">Submitted</th><th className="p-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map(a => (
              <tr key={a.id} className="border-b last:border-0">
                <td className="p-3 font-medium text-navy"><Link to={`/jobs/${a.job_id}`}>{a.job_title}</Link></td>
                <td className="p-3 text-slate-600">{a.employer_name}</td>
                <td className="p-3">
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    a.withdrawn ? "bg-slate-200 text-slate-500"
                    : a.status === "Hired" ? "bg-emerald-100 text-emerald-700"
                    : a.status === "Not Selected" ? "bg-red-100 text-red-700"
                    : "bg-slate-100 text-slate-700"
                  }`}>{a.withdrawn ? "Withdrawn" : a.status}</span>
                </td>
                <td className="p-3 text-slate-500 text-xs">{new Date(a.submitted_at).toLocaleDateString()}</td>
                <td className="p-3 text-xs">
                  {!a.withdrawn && a.status !== "Hired" && <button onClick={() => withdraw(a.id)} className="text-red-500">Withdraw</button>}
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-slate-500">
              No applications yet. <Link to="/jobs" className="text-navy font-medium">Browse jobs →</Link>
            </td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
